import { SideEnum } from 'types/api/enums'
import { ScoreSetObj } from '../types'
import { ScoreManager } from './ScoreManager'

export class FastFormatManager extends ScoreManager {
  validateSet<T extends 'set'>(score: ScoreSetObj<T>) {
    let updated: ScoreSetObj<T> | undefined

    if (!this.isScoreComplete(score)) {
      if (score.winner) {
        updated = { ...score, winner: null }
      } else if (score.tiebreak) {
        updated = { ...score, tiebreak: null }
      }
    } else if (this.hasSideWon(score, SideEnum.SIDE1)) {
      if (score.winner !== SideEnum.SIDE1 || (score.winner === SideEnum.SIDE1 && score.tiebreak))
        updated = { ...score, winner: SideEnum.SIDE1, tiebreak: null }
    } else if (this.hasSideWon(score, SideEnum.SIDE2)) {
      if (score.winner !== SideEnum.SIDE2 || (score.winner === SideEnum.SIDE2 && score.tiebreak))
        updated = { ...score, winner: SideEnum.SIDE2, tiebreak: null }
    } else if (
      this.hasPointsToWin(score, SideEnum.SIDE1) ||
      this.hasPointsToWin(score, SideEnum.SIDE2)
    ) {
      if (this.getCurrentPointsDifference(score)) {
        if (!score.tiebreak) {
          updated = {
            ...score,
            winner: this.getCurrentPointsDifference(score) > 0 ? SideEnum.SIDE1 : SideEnum.SIDE2,
            tiebreak: this.create('tiebreak'),
          }
        } else {
          const updatedTB = this.validateTiebreak(score.tiebreak)
          if (updatedTB)
            updated = {
              ...score,
              tiebreak: updatedTB,
            }
        }
      } else {
        if (score.winner) {
          updated = { ...score, winner: null }
        } else if (score.tiebreak) {
          updated = { ...score, tiebreak: null }
        }
      }
    } else if (
      !this.hasPointsToWin(score, SideEnum.SIDE1) &&
      !this.hasPointsToWin(score, SideEnum.SIDE2)
    ) {
      if (score.winner) updated = { ...score, winner: null }
    } else {
      if (score.winner) {
        updated = { ...score, winner: null }
      } else if (score.tiebreak) {
        updated = { ...score, tiebreak: null }
      }
    }

    return updated
  }
}
